import { withMetadata } from '../metadata'
import { findPhoneNumbersInText as _findPhoneNumbersInText } from '../../core/index'

export function findPhoneNumbersInText() {
	return withMetadata(_findPhoneNumbersInText, arguments)
}


//////////////////
// WEBPACK FOOTER
// ./~/libphonenumber-js/min/exports/findPhoneNumbersInText.js
// module id = 476Y
// module chunks = 0 1